import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseResource } from '../../core/abstractions/base.resource';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { PostValueResponseModel } from '../../models/core/post-value-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { DmiStatusModel } from '../../models/dmi-status.model';
import { GateGmShareholderModel } from '../../models/gate-gm-shareholder.model';
import { GateTokenModel } from '../../models/gate-token.model';
import { GmAdmissionRequestModel } from '../../models/gm-admission-request.model';
import { GmAdmissionModel } from '../../models/gm-admission.model';
import { DictionaryType } from '../../models/types/dictionary.type';

@Injectable({
    providedIn: 'root'
})
export class GateResource extends BaseResource {
    constructor() {
        super(new ResourceConfig({ baseController: 'gate' }));
    }

    getToken(): Observable<GateTokenModel> {
        return this._requestService.makeGet<GateTokenModel>(this.getUrl('token'));
    }

    getShareholderByBarcode(barcode: string): Observable<ApiResponseModel<GateGmShareholderModel>> {
        return this._requestService.makeGet<ApiResponseModel<GateGmShareholderModel>>(this.getUrl(`shareholder/${barcode}`));
    }

    checkIn(request: GmAdmissionRequestModel): Observable<ApiResponseModel<PostValueResponseModel<GmAdmissionModel>>> {
        return this._requestService.makePost<ApiResponseModel<PostValueResponseModel<GmAdmissionModel>>>(this.getUrl('check-in'), request);
    }

    checkOut(barcode: string): Observable<ApiResponseModel<PostValueResponseModel<GmAdmissionModel>>> {
        return this._requestService.makePost<ApiResponseModel<PostValueResponseModel<GmAdmissionModel>>>(this.getUrl('check-out'), barcode);
    }

    getStatus(): Observable<ApiResponseModel<DmiStatusModel>> {
        return this._requestService.makeGet<ApiResponseModel<DmiStatusModel>>(this.getUrl('status'));
    }

    registerProxies(representativeShareholderId: number, shareholderIds: number[]): Observable<ApiResponseModel<DictionaryType<boolean>>> {
        return this._requestService.makePost<ApiResponseModel<DictionaryType<boolean>>>(
            this.getUrl(`register-proxies/${representativeShareholderId}`),
            shareholderIds
        );
    }
}
